import { apolloCore } from "src/utils/apollo/apollo";
import { GetGlobalSearchResultsDocument } from "src/gql/codegen/graphql";
import initialGlobalSearchResults from "./initialGlobalSearchResults.json";

apolloCore.writeQuery({
  query: GetGlobalSearchResultsDocument,
  variables: { input: { search_term: "" } },
  data: initialGlobalSearchResults,
});
